import { ReactNode, createContext, useContext } from "react";

import { noop } from "lodash";

export interface ScreenshotFormContextState {
  values: Record<string, unknown>;
  /** Debounced update — use for free-text/number inputs the user types into. */
  onFieldChange: (name: string, value: unknown) => void;
  /** Immediate update — use for discrete controls (Switch, Select) and blur commits. */
  onFieldCommit: (name: string, value: unknown) => void;
}

const defaultState: ScreenshotFormContextState = {
  values: {},
  onFieldChange: noop,
  onFieldCommit: noop
};

export const ScreenshotFormContext =
  createContext<ScreenshotFormContextState>(defaultState);

export function ScreenshotFormProvider({
  children,
  state
}: {
  children: ReactNode;
  state: ScreenshotFormContextState;
}) {
  return (
    <ScreenshotFormContext.Provider value={state}>
      {children}
    </ScreenshotFormContext.Provider>
  );
}

export function useScreenshotFormContext(): ScreenshotFormContextState {
  return useContext(ScreenshotFormContext);
}
